import "./CourseItem.scss";
import ModuleItem from "./ModuleItem";
import CourseDetails from "components/CourseDetails/CourseDetails";

const CourseItem = ({ course, expandedModuleId, onExpand }) => {
	const courseId = course.Id;

	return (
		<div className="list-view-item" id={`courseId-${courseId}`}>
			<CourseDetails course={course} />

			<h3>Modules</h3>

			{(course.SubContent ?? []).map((module, index) => {
				const moduleId = module.Id;

				const key = `course-${courseId}-module-${moduleId}-row-${index}`;

				return (
					<div key={key}>
						<ModuleItem
							module={module}              
							course={course}               
							expandedModuleId={expandedModuleId}
							onExpand={onExpand}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default CourseItem;